import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import FadeIn from '../components/common/FadeIn.jsx';
import {
  ArrowRightIcon,
  BookIcon,
  ScholarsIcon,
  BuildingIcon,
  AcademicCapIcon,
  NewspaperIcon,
  EnvelopeIcon,
  ArchiveBoxIcon,
  GlobeIcon,
} from '../components/icons/Icons.jsx';

// The entry points into the Commons. This grid used to live on the
// homepage; it now has its own page at /explore so the homepage hero
// can breathe and so the "Explore" nav link lands users in a single,
// canonical jumping-off point. (A "Contribute" tile previously sat
// here too, but contribute actions live on each resource page's "Add
// entry" button, so a standalone tile pointing at /auth was a dead end.)
const TILES = [
  { key: 'bibliography', to: '/bibliography', Icon: BookIcon },
  { key: 'scholars', to: '/scholars', Icon: ScholarsIcon },
  { key: 'organizations', to: '/organizations', Icon: BuildingIcon },
  { key: 'teaching', to: '/teaching', Icon: AcademicCapIcon },
  { key: 'whats_new', to: '/whats-new', Icon: NewspaperIcon },
  { key: 'newsletter', to: '/newsletter', Icon: EnvelopeIcon },
  { key: 'research_tools', to: '/research-tools', Icon: ArchiveBoxIcon },
  { key: 'broader_engagements', to: '/broader-engagements', Icon: GlobeIcon },
];

export default function Explore() {
  const { t } = useTranslation();
  return (
    <section className="section">
      <header className="section-header">
        <div className="section-label">{t('home.explore.label')}</div>
        <h1 className="section-title">{t('home.explore.title')}</h1>
        <p className="section-subtitle">{t('home.explore.subtitle')}</p>
      </header>

      <div className="cards">
        {TILES.map(({ key, to, Icon }) => (
          <FadeIn key={key}>
            <Link to={to} className="card block">
              <div className="card-icon">
                <Icon />
              </div>
              <h2 className="card-title">{t(`home.tiles.${key}.title`)}</h2>
              <p className="card-body">{t(`home.tiles.${key}.description`)}</p>
              <span className="card-link">
                {t(`home.tiles.${key}.cta`)}
                <ArrowRightIcon />
              </span>
            </Link>
          </FadeIn>
        ))}
      </div>
    </section>
  );
}
